import { RevCard, RevLink } from "@revmatics/catalyst";
import { useFlags } from "launchdarkly-react-client-sdk";

export const SubscriptionSettingsPage = () => {
  const { showCroLinks: ffShowCroLinks } = useFlags();
  return (
    <div className="space-y-6 max-w-[560px] mx-auto">
      <h4 className="text-monochrome-900">Subscription</h4>
      <RevCard title="Current  Subscription" className="">
        <div className="typography-body-sm text-monochrome-900">
          At the moment, subscription changes cannot be made within the app. To
          update or modify your subscription, please contact our support team{" "}
          <a
            href="mailto:support@revmatics.ai"
            className="underline hover:no-underline"
          >
            support@revmatics.ai
          </a>
          .
        </div>
        <RevLink
          pathname="/contact-us"
          displayAs="button"
          buttonSize="medium"
          text="Contact us"
          className="mt-6"
        />
      </RevCard>
      {ffShowCroLinks && (
        <RevCard
          bgColor="bg-primary-500/15"
          className="flex flex-col gap-6 justify-center items-center"
          padding="p-6"
        >
          <div className="space-y-2">
            <h4 className="text-monochrome-900 text-center">
              Become An Affiliate
            </h4>
            <p className="typography-body-sm text-monochrome-900 text-center">
              Boost Your Income by Helping Others Increase Conversions!
            </p>
            <p className="typography-body-sm text-monochrome-900 text-center">
              Love the CRO Suite? Get paid to share it with your network of
              marketing and business professionals. Discover a simple way to
              generate extra income by helping others learn the secret to higher
              conversion rates.
            </p>
          </div>

          <RevLink
            pathname={`${import.meta.env.VITE_CRO_API_URL}/funnels`}
            local={false}
            target="_self"
            displayAs="button"
            buttonVariant="secondary"
            buttonSize="medium"
            text="Learn More"
          />
        </RevCard>
      )}
    </div>
  );
};
